import { jsx } from 'react/jsx-runtime';
import { mergeStyleSets, Text } from '@fluentui/react';
import { omitSpecialChars } from '../../omitSpecialChars.esm.js';
import { useMemo } from 'react';

var styles = mergeStyleSets({
    bold: {
        fontWeight: 'bold'
    }
});
var useHighlightMatchingWords = function(param) {
    var searchTerm = param.searchTerm, title = param.title;
    return useMemo(function() {
        if (!title) {
            return null;
        }
        var findRegex = new RegExp("(".concat(omitSpecialChars(searchTerm), ")"), 'ig');
        return title.replace(findRegex, "<strong>__$1__<strong>").split('<strong>').map(function(word, index) {
            if (word.startsWith('__') && word.endsWith('__')) {
                return /*#__PURE__*/ jsx(Text, {
                    className: styles.bold,
                    as: "span",
                    children: word.replace(/__/g, '')
                }, "suggestion-title-".concat(title, "-").concat(word, "-").concat(index));
            }
            return word;
        });
    }, [
        title,
        searchTerm
    ]);
};
var SuggestionTitle = function(param) {
    var title = param.title, searchTerm = param.searchTerm;
    var titleToDisplay = useHighlightMatchingWords({
        title: title,
        searchTerm: searchTerm
    });
    return /*#__PURE__*/ jsx(Text, {
        as: "h2",
        children: titleToDisplay
    });
};

export { SuggestionTitle as default };
